import React from 'react';
import { Link } from '@remix-run/react';
import { AnimatedImage } from '~/routes/_layout.about/components/animated-image';

export default function CatalystRewards() {
  return (
    <section
      aria-labelledby="catalyst-rewards-heading"
      className="w-full bg-white bg-[url('/images/catalyst-light-bg-stoner-mobile-optimized.webp')] bg-cover bg-scroll bg-center bg-no-repeat"
    >
      <h2 id="catalyst-rewards-heading" className="sr-only">
        Catalyst Rewards loyalty program
      </h2>
      <div className="mx-auto w-full max-w-[108rem]">
        <div className="flex flex-col items-center md:flex-row">
          {/* First Image Section */}
          <div className="group relative w-full">
            <AnimatedImage
              src="/images/CATALYST-REWARDS.webp"
              alt="Catalyst Rewards"
              className="mx-auto object-cover"
              animationClass="animate-slideInLeft"
            />
          </div>

          {/* Second Image Section with Link */}
          <div className="group relative w-full">
            <Link
              to="/rewards"
              className="w-full"
              aria-label="Join the Catalyst Rewards loyalty program"
            >
              <AnimatedImage
                src="/images/CATALYST-LOYALTY-PROGRAM.webp"
                alt="Catalyst loyalty programme"
                className="mx-auto object-cover"
                animationClass="animate-slideInRight"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
